import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type PocketByType = paths['/v3/profile/'];

const getProfile = createRequest<PocketByType>('/pc/v3/profile/');

export default getProfile;
